import { DocportalWelcome } from "@components/HomePage/Welcome/Docportal";
import { EditorWelcome } from "@components/HomePage/Welcome/Editor";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";

const NoneGroups = ({ isLoadingAvailableCatalogs }: { isLoadingAvailableCatalogs: boolean }) => {
	const isReadOnly = PageDataContextService.value.conf.isReadOnly;

	return (
		<div className="my-auto flex h-[inherit] w-[inherit] items-center justify-center">
			{isReadOnly ? (
				<DocportalWelcome />
			) : (
				<EditorWelcome isLoadingAvailableCatalogs={isLoadingAvailableCatalogs} />
			)}
		</div>
	);
};

export default NoneGroups;
